import { useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { toast } from "sonner";
import { submitLead } from "@/lib/api";

export const Footer = () => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  const onSubscribe = async (e) => {
    e.preventDefault();
    if (!email) return;
    setLoading(true);
    try {
      await submitLead({ type: "newsletter", email });
      toast.success("You're in. One calm email, every Sunday.");
      setEmail("");
    } catch {
      toast.error("Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <footer data-testid="site-footer" className="bg-sage text-sand">
      <div className="max-w-[1400px] mx-auto px-6 sm:px-10 py-24 sm:py-32">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-16">
          <div className="lg:col-span-6">
            <p className="text-xs uppercase tracking-[0.25em] text-sand/60 mb-6">
              The Sunday Unwind
            </p>
            <h3 className="font-serif text-4xl sm:text-5xl font-light leading-tight mb-10">
              One calm email a week on building a business that doesn't eat your life.
            </h3>
            <form
              data-testid="footer-newsletter-form"
              onSubmit={onSubscribe}
              className="flex items-center gap-0 max-w-md border-b border-sand/30 focus-within:border-clay transition-colors duration-300"
            >
              <input
                data-testid="footer-newsletter-email-input"
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="your@email.com"
                className="flex-1 bg-transparent py-4 text-sand placeholder:text-sand/40 outline-none text-base"
              />
              <button
                data-testid="footer-newsletter-submit-button"
                type="submit"
                disabled={loading}
                className="p-4 text-clay hover:translate-x-1 transition-transform duration-300 disabled:opacity-50"
                aria-label="Subscribe"
              >
                <ArrowRight className="w-5 h-5" />
              </button>
            </form>
          </div>

          <div className="lg:col-span-3 lg:col-start-9">
            <p className="text-xs uppercase tracking-[0.25em] text-sand/60 mb-6">Explore</p>
            <nav className="flex flex-col gap-4">
              <Link to="/method" data-testid="footer-link-method" className="text-sand/80 hover:text-clay transition-colors duration-300 w-fit">The Method</Link>
              <Link to="/programs" data-testid="footer-link-programs" className="text-sand/80 hover:text-clay transition-colors duration-300 w-fit">Programs</Link>
              <Link to="/contact" data-testid="footer-link-contact" className="text-sand/80 hover:text-clay transition-colors duration-300 w-fit">Contact</Link>
            </nav>
          </div>

          <div className="lg:col-span-2">
            <p className="text-xs uppercase tracking-[0.25em] text-sand/60 mb-6">Elsewhere</p>
            <div className="flex flex-col gap-4">
              <a href="https://instagram.com" target="_blank" rel="noreferrer" data-testid="footer-link-instagram" className="text-sand/80 hover:text-clay transition-colors duration-300 w-fit">Instagram</a>
              <a href="https://linkedin.com" target="_blank" rel="noreferrer" data-testid="footer-link-linkedin" className="text-sand/80 hover:text-clay transition-colors duration-300 w-fit">LinkedIn</a>
            </div>
          </div>
        </div>

        <div className="mt-24 pt-8 border-t border-sand/15 flex flex-col sm:flex-row justify-between gap-4">
          <p className="font-serif text-xl">KLA Consulting<span className="text-clay">.</span></p>
          <p className="text-sm text-sand/50">Scale what you love. Skip the burnout.</p>
        </div>
      </div>
    </footer>
  );
};
